import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_BRIOSE, scrollToSection } from "./Navbar";

const BRIOSE_1 =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_dolce-portfolio/artifacts/163c97684794f144_gpt-image-2.5-flare_Usa_la_PRIMA_immagine_caricata_esclusivamente_come_riferimento_visivo_per_lo_sti-0%20%285%29.webp";
const BRIOSE_2 =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_dolce-portfolio/artifacts/1913845b96748d32_gpt-image-2.5-flare_Usa_la_PRIMA_immagine_caricata_esclusivamente_come_riferimento_visivo_per_lo_sti-2.webp";

const FLAVORS = [
  { name: "Briosé Regina", desc: "base composta di ciliegia, crema pasticcera e frutti di bosco" },
  { name: "Briosé Ambra", desc: "base crema al caramello, con crema chantilly e decorazioni al caramello" },
  { name: "Briosé Mediterranea", desc: "riempita con ricotta di pecora, fico fresco e granella di pistacchio" },
  { name: "Briosé Coccola", desc: "base di cioccolato fondente, crema chantilly al cioccolato e cocco" },
  { name: "Briosé Incanto", desc: "crema alla cannella con composta di mele all'interno, finita con crema chantilly e mela" },
  { name: "Briosé Smeralda", desc: "base crema al pistacchio, crema chantilly e granella di pistacchio come decorazione" },
  { name: "Briosé Rubino", desc: "base di composta di ciliegia, crema chantilly e crema croccante ai frutti rossi" },
  { name: "Briosé Perla Nera", desc: "savoiardo al caffè Illy, crema al mascarpone e cacao" },
  { name: "Briosé Esotica", desc: "base di composta di mango, crema chantilly e mango in superficie" },
  { name: "Briosé Preziosa", desc: "zabaione, composta di fragole alla base con crema pasticcera, decorazione di fragola e zabaione" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Novita = () => (
  <section id="novita" className="py-24 sm:py-32 border-t border-[#e6dacb]" data-testid="novita-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex items-center gap-4 text-[0.7rem] uppercase tracking-[0.35em] font-medium text-[#84232a] mb-6"
            data-testid="novita-eyebrow"
          >
            <span className="w-10 h-px bg-[#84232a]/50" />
            La novità · in vetrina ora
          </motion.p>

          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-display text-5xl sm:text-6xl font-medium text-black leading-[1.02]"
            data-testid="novita-title"
          >
            Le Briosé,{" "}
            <span className="font-script text-[#84232a] font-normal">appena sfornate.</span>
          </motion.h2>

          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-[#4a423d] text-base sm:text-lg leading-relaxed mt-7 max-w-md font-light"
            data-testid="novita-text"
          >
            Brioche tonde, soffici e a lenta lievitazione, con un cuore tutto da
            scoprire. Dieci gusti irresistibili che stanno già conquistando tutti
            al primo morso.
          </motion.p>

          <motion.p
            variants={fadeUp}
            custom={3}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-display italic text-xl sm:text-2xl text-black mt-7 max-w-md leading-snug"
            data-testid="novita-claim"
          >
            È arrivata la novità: prenotala su WhatsApp per essere sicuro di trovarla.
          </motion.p>

          <motion.div
            variants={fadeUp}
            custom={4}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex flex-wrap items-center gap-5 mt-9"
          >
            <a
              href={WA_BRIOSE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="novita-cta-whatsapp"
              className="group flex items-center gap-3 bg-[#84232a] text-[#fbf6f1] px-8 py-4 rounded-full text-sm font-medium hover:bg-[#63191f] transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" />
              Prenota la tua Briosé
            </a>
            <a
              href="#contatti"
              onClick={(e) => scrollToSection(e, "#contatti")}
              data-testid="novita-cta-visit"
              className="text-sm font-medium text-black/70 underline underline-offset-8 decoration-[#84232a]/40 hover:decoration-[#84232a] hover:text-[#84232a] transition-colors duration-300"
            >
              O passa a trovarci
            </a>
          </motion.div>
        </div>

        <div className="relative flex justify-center gap-5 sm:gap-7">
          <motion.figure
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="w-1/2 max-w-[260px]"
          >
            <div className="rounded-2xl overflow-hidden border border-[#e6dacb] aspect-[4/5]">
              <img
                src={BRIOSE_1}
                alt="Briosé ricotta e fico con granella di pistacchio"
                loading="lazy"
                className="w-full h-full object-cover"
                data-testid="novita-photo-1"
              />
            </div>
            <figcaption className="text-xs text-[#4a423d] tracking-wide mt-3 text-center">
              Briosé ricotta e fico
            </figcaption>
          </motion.figure>
          <motion.figure
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-60px" }}
            className="w-1/2 max-w-[260px] mt-12"
          >
            <div className="rounded-2xl overflow-hidden border border-[#e6dacb] aspect-[4/5]">
              <img
                src={BRIOSE_2}
                alt="Briosé tiramisù con crema al mascarpone, cacao e savoiardo"
                loading="lazy"
                className="w-full h-full object-cover"
                data-testid="novita-photo-2"
              />
            </div>
            <figcaption className="text-xs text-[#4a423d] tracking-wide mt-3 text-center">
              Briosé tiramisù
            </figcaption>
          </motion.figure>
        </div>
      </div>

      <div id="gusti" className="mt-20 sm:mt-24" data-testid="novita-flavors">
        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-script text-3xl sm:text-4xl text-[#84232a] text-center"
          data-testid="novita-flavors-title"
        >
          dieci gusti, un solo vizio
        </motion.p>
        <div className="grid sm:grid-cols-2 gap-x-14 mt-10 max-w-4xl mx-auto">
          {FLAVORS.map((f, i) => (
            <motion.div
              key={f.name}
              variants={fadeUp}
              custom={i % 5}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-40px" }}
              className="flex items-baseline gap-4 border-t border-[#e6dacb] py-4 last:border-b sm:[&:nth-last-child(2)]:border-b"
              data-testid={`flavor-${i}`}
            >
              <span className="font-display text-sm text-[#84232a] w-7 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex flex-wrap items-baseline gap-x-3">
                <h3 className="font-display text-lg sm:text-xl font-semibold text-black">
                  {f.name}
                </h3>
                <span className="text-xs sm:text-sm text-[#4a423d] font-light">{f.desc}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
